export default "__VITE_ASSET__DDLJ$WvV__"